/**
 * Company: AltSolution
 * Author: Ivan Horobets
 */

"use strict";


if($('.checkout_wrap-cart').length) {
    /**
     * Promo codes
     */
    let $promoCodes = $('.promo-area'),
        $promList = $('.promos-active');
    let $promoCodesInit = $promoCodes.validate({
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function(form){
            let $form = $(form),
                action = $form.attr('action'),
                code = $form.find('input[name="promo_code"]').val().replace(/ /g,""),
                formData = {promo_code: code};
            ajaxPromo($promoCodesInit, action, formData);
        }
    });

    $(document).on('click', '.promocode-delete', function(e) {
        e.preventDefault();

        let $this = $(this),
            action = $this.closest('form').attr('action'),
            code = $this.closest('li').attr('data-code').replace(/ /g,""),
            formData = {promo_code: code, is_delete: 'true'};

        ajaxPromo($this, action, formData);
    });

    function ajaxPromo($this, action, formData) {
        //$this.prop('disabled', true);
        //NOTE TYPE: 1 - percent, 2 - uah

        $.ajax({
            type: "POST",
            url: action,
            data: formData,
            dataType: "json",
            success: function(res, textStatus, jqXHR) {
                console.log(res);
                if(res.success) {
                    $promList.html('');
                    for (const property in res.data) {
                        $promList.append(res.data[property].html);
                    }
                    $promList.show();

                    $promoCodesInit.resetForm();
                    $promoCodes[0].reset();
                } else {
                    $this.showErrors({promo_code: res.message});
                }

                $(document).trigger('calculate.cart');

                //$this.prop('disabled', false);
            },
            error: function(jqXHR, textStatus, errorThrown) {
                if(jqXHR.status === 422) {
                    let errorObj = {};
                    if(jqXHR.responseJSON.errors) {
                        const objErrors = jqXHR.responseJSON.errors;
                        for (let property in objErrors) {
                            errorObj[property] = objErrors[property].join(',');
                        }
                    }
                    $this.showErrors(errorObj);
                }

                //$this.prop('disabled', false);
            }
        });
    }
}


if($('.checkout_order').length) {

    const LANGUAGE = document.getElementsByTagName('html')[0].getAttribute('lang');

    window.ALL_DATA = {};

    /**
     * Step 1
     */
    //Register
    let $checkoutRegisterForm = $('#checkout_register');

    //Hack for fucking chrome!!!!!!!
    setTimeout(function () {
        $checkoutRegisterForm.find('input').prop('readonly', false);
    }, 1500);

    let $checkoutRegisterFormInit = $checkoutRegisterForm.validate({
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function(form){
            var formData = new FormData($(form)[0]);
            $(form).find('button[type=submit]').prop('disabled', true);
            $.ajax({
                type: "POST",
                url: '/' + LANGUAGE + '/register',
                processData: false,
                contentType: false,
                data: formData
            }).done(function (data) {
                if(data.errors) {
                    var err = {};
                    $(form).find('button[type=submit]').prop('disabled', false);
                    Object.keys(data.errors).forEach(function(key) {
                        err[key] = data.errors[key][0];
                    });
                    $checkoutRegisterFormInit.showErrors(err);
                } else if (data.success) {
                    $checkoutRegisterForm.closest('.checkout_wrap_row').find('.ch_l').addClass('no_edit');
                    insertIserData(data.data.id, data.data.name, data.data.surname, data.data.phone, data.data.email);

                    let from = $(form).closest('.checkout_wrap_row').attr('id'),
                        to = $(form).closest('.checkout_wrap_row').attr('data-to');

                    secondSlide(from, to);

                    //Some fix
                    setTimeout(function () {
                        defaultKiev();
                    }, 200);
                }
            });
        }

    });

    //Login
    let $checkoutLoginForm = $('#send_sms'),
        $checkoutCodeForm = $('#enter_number'),
        intervalTimer = null;

    let $checkoutLoginFormInit = $checkoutLoginForm.validate({
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function(form){

            let phoneNumber = $(form).find('#login_phone').val();

            $.ajax({
                type: "POST",
                url: '/sms-auth',
                data: {phone: phoneNumber}
            }).done(function (data) {
                if(data.success) {
                    $checkoutLoginForm.fadeOut(200, function () {
                        $checkoutCodeForm.fadeIn(200);
                        intervalTimer = sendAgain($checkoutCodeForm.find('.send-again'));
                    });
                }
                if(data.error) {
                    $checkoutLoginFormInit.showErrors({
                        users_phone: data.error
                    });
                }
            });
        }
    });

    let $checkoutCodeFormInit = $checkoutCodeForm.validate({
        highlight: function(element) {
            $(element).parent().addClass("error").removeClass("valid");
        },
        unhighlight: function(element) {
            $(element).parent().removeClass("error").addClass("valid");
        },
        submitHandler: function(form){

            $.ajax({
                type: "POST",
                url: '/sms-code-check',
                data: {code: $(form).find('input[name="user_code"]').val()}
            }).done(function (data) {
                if(data.success) {
                    insertIserData(data.data.id, data.data.name, data.data.surname, data.data.phone, data.data.email);
                    $checkoutRegisterForm.closest('.checkout_wrap_row').find('.ch_l').addClass('no_edit');

                    var from = $(form).closest('.checkout_wrap_row').attr('id'),
                        to = $(form).closest('.checkout_wrap_row').attr('data-to');
                    secondSlide(from, to);

                    //Some fix
                    setTimeout(function () {
                        defaultKiev();
                    }, 200);
                }
                if(data.error) {
                    $checkoutCodeFormInit.showErrors({
                        user_code: data.error
                    });
                }
            });
        }
    });

    $checkoutCodeForm.on('click', '.send-again:not(.disabled)', function () {
        intervalTimer = sendAgain($(this));
    });

    //Reset forms when user change tabs
    let $rFirst = $('#row_first');
    $rFirst.find('.tab_controls').on('click', 'a:not(.active, .disabled)', function () {
        $checkoutRegisterForm[0].reset();
        $checkoutRegisterFormInit.resetForm();

        $checkoutLoginForm[0].reset();
        $checkoutLoginFormInit.resetForm();

        $checkoutCodeForm[0].reset();
        $checkoutCodeFormInit.resetForm();

        $checkoutCodeForm.fadeOut(0, function () {
            $checkoutLoginForm.fadeIn(0);
        });

        clearInterval(intervalTimer);
    });


    /**
     * Step 2
     */
    let $rSecond = $('#row_second');
    for(let i = 1; i <= 3; i++) {
        let $fDelivery = $('#checkout_d-' + i);
        let $fDeliveryInit = $fDelivery.validate({
            highlight: function(element) {
                $(element).parent().addClass("error").removeClass("valid");
            },
            unhighlight: function(element) {
                $(element).parent().removeClass("error").addClass("valid");
            },
            submitHandler: function(form){

                var from = $(form).closest('.checkout_wrap_row').attr('id'),
                    to = $(form).closest('.checkout_wrap_row').attr('data-to');

                watchTypeDelivery($rSecond);
                secondSlide(from, to);
            }
        });

        //Reset forms when user change tabs
        if(i > 1) {
            $rSecond.find('.tab_controls').on('click', 'a:not(.active, .disabled)', function () {

                $fDelivery[0].reset();
                $fDeliveryInit.resetForm();

                $fDelivery.find('input[name="flat_delivery"]').attr('value', '');

                //Hide delivery price
                $rSecond.find('.cost_delivery:not(.free)')
                    .attr('data-cost', 0)
                    .css('display', 'none');

                //Disabled warehouse
                let $forms = $('#checkout_d-3');
                $forms.find('.drop_down_search:nth-child(2)').addClass('disabled');
                $forms.find('input[name="address_delivery"]').prop('disabled', true);

                //Reset active class
                $('.delivery_info:not(#delivery_1) .drop_down-list li').removeClass('active');

            });
        }
    }

    //Set default kiev | TEMPORARY
    window.onload = function() {
        defaultKiev();
    };

    //Select City && load shops|warehouses
    $rSecond.find('input[name="city_delivery"]').blur(function () {
        let $this = $(this);

        //Get shops || warehouses
        if($this.attr('data-ajax') === 'true') {
            setTimeout(function () {
                $.ajax({
                    type: "POST",
                    url: $this.attr('data-url'),
                    data: {id: $this.attr('data-id')}
                }).done(function (data) {

                    $this.closest('form').find('.address_delivery_list .mCSB_container').html(data.li);

                    $this.closest('form').find('.drop_down').removeClass('disabled');
                    $this.closest('form').find('input[name="address_delivery"]').val('');
                    $this.closest('form').find('input[name="address_delivery"]').prop('disabled', false);

                    //Fix if only one shop
                    //TODO: This is temporary solution for 1 city
                    let lengthLi = $this.closest('form').find('.address_delivery_list .mCSB_container li:not(.empty)').length;

                    if(lengthLi === 1) {
                        $this.closest('form').find('.address_delivery_list .mCSB_container li:nth-child(2)').trigger('click');
                    }else if(lengthLi === 0) {
                        $this.closest('.tab_area').find('a[data-id="delivery_2"]').trigger('click');
                        $this.closest('.tab_area').find('a[data-id="delivery_1"]').addClass('disabled');
                    }

                });
            }, 200);
        }

        //Get cost delivery
        if($this.attr('data-cost') === 'true') {
            setTimeout(function () {
                if(!$this.attr('data-id')) return false;
                $.ajax({
                    type: "POST",
                    url: $this.attr('data-cost-url'),
                    data: {city_id: $this.attr('data-id')}
                }).done(function (data) {

                    let $costDelivery = $this.closest('form').find('.cost_delivery'),
                        costD = 0;

                    if($this.closest('form').attr('id') === 'checkout_d-2') {
                        $costDelivery.attr('data-cost', data.home_value);
                        $costDelivery.find('.del-price').html(data.home_value);
                        costD = data.home_value;
                        sumPriceAndDelivery(data.home_value);
                    }
                    if($this.closest('form').attr('id') === 'checkout_d-3') {
                        $costDelivery.attr('data-cost', data.post_value);
                        $costDelivery.find('.del-price').html(data.post_value);
                        costD = data.post_value;
                        sumPriceAndDelivery(data.post_value);
                    }
                    if(costD > 0) {
                        $costDelivery.find('.price_d').removeAttr('style');
                        $costDelivery.find('.free_d').css('display', 'none');
                    } else {
                        $costDelivery.find('.price_d').css('display', 'none');
                        $costDelivery.find('.free_d').removeAttr('style');
                    }
                    $costDelivery.removeAttr('style');
                });
            }, 200);
        }
    });

    /**
     * Step 3
     */
    $('#pay-selected').on('click', function () {
        getAllInfo();
        buildData();

        var from = $(this).closest('.checkout_wrap_row').attr('id'),
            to = $(this).closest('.checkout_wrap_row').attr('data-to');
        secondSlide(from, to);
    });


    /**
     * Step 4
     */
    let $moreInfo = $('.more_info'),
        $rFourth = $('#row_fourth');
    $moreInfo.find('> a').on('click', function () {
        $(this).siblings('.form-group').slideToggle(200);
    });

    $rFourth.find('.send-order').on('click', function () {
        let $this = $(this);
        if($this.hasClass('disabled')) return false;

        $this.addClass('disabled');

        getAllInfo();
        $.ajax({
            type: "POST",
            url: '/' + LANGUAGE + '/order',
            data: window.ALL_DATA
        }).done(function (data) {
            //ecommerce
            ecommerceGa(5);

            //$this.removeClass('disabled');
            location.href = data.success.url;
        })
    });

    /**
     * Edit rows
     */
    $('.checkout_tabs').on('click', '.checkout_wrap_row .ch_l:not(.disabled)', function (e) {
        e.preventDefault();
        let $this = $(this);

        if($this.hasClass('no_edit')) return false;

        if($this.siblings('.ch_content').css('display') !== 'none') return false;
        let $openBl = $('.checkout_wrap_row .ch_l.edit').siblings('.ch_content');

        if(validCloseBlock($openBl)) {
            $('.checkout_wrap_row .ch_content').slideUp(200);
            $this.siblings('.ch_content').slideDown(200, function () {
                $('.checkout_content .checkout_wrap_row').removeClass('edit_hide');
                //$(this).parent().addClass('edit_hide');
                $this.addClass('edit');
                $openBl.siblings('.ch_l').removeClass('edit');
                getAllInfo();
                buildData();
            });
        }

        // if($(this).closest('.checkout_wrap_row').attr('id') === 'row_fourth') {
        //     //getAllData();
        // }
    });

}

//General

/**
 * Show|hide online type pay
 * @param $rSecond
 */
function watchTypeDelivery($rSecond) {
    let type = $rSecond.find('.tab_controls a.active').attr('data-type');

    if(type === '1') {
        $('#row_third .ch_content .form-group:nth-child(2)').css('display', 'none');
        if($('#row_third .ch_content .form-group:nth-child(2) input[type="radio"]:checked')) {
            $('#row_third .ch_content .form-group input[type="radio"]').prop('checked', false);
            $('#row_third .ch_content .form-group:nth-child(1) input[type="radio"]').prop('checked', true);
        }
    } else {
        $('#row_third .ch_content .form-group:nth-child(2)').removeAttr('style');
    }
}

/**
 * Set default kiev
 * //TODO: temporary
 */
function defaultKiev() {
    let $kiev = $('#checkout_d-1 .drop_down:first-child li[data-id=1]');
    $kiev.addClass('active');
    $('#checkout_d-1 input[name="city_delivery"]')
        .val($kiev.html()).attr('data-id', '1').focus();
    setTimeout(function () {
        $('#checkout_d-1 input[name="city_delivery"]').blur();
    }, 50);
}

/**
 * Insert data for user in step4
 */
function buildData() {
    let $fourRow = $('#row_fourth');

    //User data
    $fourRow.find('li.user_name .value').html(window.ALL_DATA.user_name);
    $fourRow.find('li.user_surname .value').html(window.ALL_DATA.user_surname);
    $fourRow.find('li.user_phone .value').html(window.ALL_DATA.user_phone);
    $fourRow.find('li.user_email .value').html(window.ALL_DATA.user_email);

    //Delivery
    $fourRow.find('li.type_delivery .value').css('display', 'none');
    $fourRow.find('li.type_delivery .value_' + (window.ALL_DATA.type_delivery)).removeAttr('style');
    $fourRow.find('li.address_delivery .value').html(window.ALL_DATA.city_delivery + ', ' + window.ALL_DATA.address_delivery);
    $fourRow.find('li.address_delivery_street .value').html(window.ALL_DATA.address_delivery);
    $fourRow.find('li.address_delivery_build .value').html(window.ALL_DATA.build_delivery);
    $fourRow.find('li.address_delivery_flat .value').html(window.ALL_DATA.flat_delivery);

    if(window.ALL_DATA.type_delivery === '2') {
        $fourRow.find('.address_delivery_street, .address_delivery_build').removeAttr('style');
        if(window.ALL_DATA.flat_delivery.length) {
            $fourRow.find('.address_delivery_flat').removeAttr('style');
        } else {
            $fourRow.find('.address_delivery_flat').css('display', 'none');
        }
    } else {
        $fourRow.find('.address_delivery_street, .address_delivery_build, .address_delivery_flat').css('display', 'none');
    }

    //Type Pay
    $fourRow.find('li.type_pay .value').css('display', 'none');
    $fourRow.find('li.type_pay .value_' + (window.ALL_DATA.type_pay)).removeAttr('style');

    //Prices
    let priceWitchDiscount = Number(window.ALL_DATA.price) + Number(window.ALL_DATA.discount_price);
    $fourRow.find('li.price .value b').html(priceWitchDiscount.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
    $fourRow.find('li.cost_delivery_r .value').css('display', 'none');

    if(Number(window.ALL_DATA.discount_price) > 0) {
        $fourRow.find('li.price_discount .value b').html('-' + Number(window.ALL_DATA.discount_price).toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
        $fourRow.find('li.price_discount').removeAttr('style');
    } else {
        $fourRow.find('li.price_discount').css('display', 'none');
    }

    if(Number(window.ALL_DATA.cost_delivery) > 0) {
        $fourRow.find('li.cost_delivery_r .value_1').css('display', 'none');
        $fourRow.find('li.cost_delivery_r .value_1 b')
            .html(Number(window.ALL_DATA.cost_delivery).toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}))
            .parent().removeAttr('style');
    } else {
        $fourRow.find('li.cost_delivery_r .value_1').css('display', 'none');
        $fourRow.find('li.cost_delivery_r .value_2').removeAttr('style');
    }

    //Total
    let totalB = Number(window.ALL_DATA.price) + Number(window.ALL_DATA.cost_delivery);
    $fourRow.find('.total-big').html(totalB.toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
}

/**
 * Set & sum price and cost delivery
 * @param cost
 */
function sumPriceAndDelivery(cost) {
    let $smallOrder = $('.small_list_order');
    $smallOrder.find('input[name="cost_delivery"]').val(cost);

    $smallOrder.find('#total').html(Number($smallOrder.find('input[name="cost"]').val()).toLocaleString('ru-RU', {maximumFractionDigits: 0, minimumFractionDigits: 0}));
}


/**
 * insert all data to global variable
 * @ window.ALL_DATA
 */
function getAllInfo() {
    //User data
    let $fRow = $('#row_first'),
        rex = /(<([^>]+)>)/ig;

    window.ALL_DATA.user_id = $fRow.find('input[name="user_id"]').val();
    window.ALL_DATA.user_name = $fRow.find('input[name="user_name"]').val().replace(rex , "");
    window.ALL_DATA.user_surname = $fRow.find('input[name="user_surname"]').val().replace(rex , "");
    window.ALL_DATA.user_phone = $fRow.find('input[name="user_phone"]').val().replace(rex , "");
    window.ALL_DATA.user_email = $fRow.find('input[name="user_email"]').val().replace(rex , "");

    //Delivery
    let $deliveryArea = $('#row_second'),
        $activeNav = $deliveryArea.find('.tab_controls a.active'),
        $activeCont = $deliveryArea.find('#' + $activeNav.attr('data-id'));

    window.ALL_DATA.type_delivery = $activeNav.attr('data-type');
    window.ALL_DATA.city_delivery = $activeCont.find('input[name="city_delivery"]').val().replace(rex , "");
    window.ALL_DATA.address_delivery = $activeCont.find('input[name="address_delivery"]').val().replace(rex , "");
    if($activeCont.find('input[name="build_delivery"]').length) {
        window.ALL_DATA.build_delivery = $activeCont.find('input[name="build_delivery"]').val().replace(rex , "");
    }
    if($activeCont.find('input[name="flat_delivery"]').length) {
        window.ALL_DATA.flat_delivery = $activeCont.find('input[name="flat_delivery"]').val().replace(rex , "");
    }
    window.ALL_DATA.cost_delivery = $activeCont.find('.cost_delivery').attr('data-cost');

    //Type pay
    let $payArea = $('#row_third');
    window.ALL_DATA.type_pay = $payArea.find('input[type="radio"]:checked').val();

    //Price
    let $smArea = $('.small_list_order');
    window.ALL_DATA.price = $smArea.find('input[name="cost"]').val();
    window.ALL_DATA.discount_price = $smArea.find('input[name="discount_cost"]').val();

    //Get comment
    window.ALL_DATA.more_info = $('#row_fourth textarea[name="more_info"]').val();

}

/**
 * Change row
 * @param from
 * @param to
 */
function secondSlide(from, to) {
    let $from = $('#'+from),
        $to = $('#'+to);

    //TODO: потрібен для блокування блоку від редагування
    //$('.checkout_content .checkout_wrap_row').removeClass('edit_hide');

    $from.find('.ch_l').addClass('ok').removeClass('edit');
    $from.find('.ch_content').slideUp(200);

    $to.find('.ch_l').removeClass('disabled').addClass('edit').parent().addClass('edit_hide');
    $to.find('.ch_content').slideDown(200);

    //Push ecommerce GA
    ecommerceGa($from.attr('data-ecommerce-index'));
    if(from === 'row_second') {
        ecommerceGaDelivery($('#row_second .tab_controls a.active').html());
    }
    if(from === 'row_third') {
        ecommerceGaPay($('#row_third .ch_content input:checked + label').html().replace(/<[^>]*>?/gm, ''))
    }
}

/**
 *
 * @param $element
 */
function validCloseBlock($element) {
    let result = true;
    $element.find('.tab_content').each(function () {
        if($(this).css('display') !== 'none') {
            let $visibleForm = $(this).find('form');
            if ($visibleForm.valid()) {
                result = true;
                return false;
            } else {
                result = false;
                return false;
            }
        }
    });

    return result;
}

/**
 *
 * @param $timer
 * @returns {number}
 */
function sendAgain($timer) {
    $timer.addClass('disabled');

    let time = $timer.attr('data-time');
    $timer.find('span').html(time);
    $timer.find('span').removeAttr('style');

    let timerInterval = setInterval(function () {
        time--;
        $timer.find('span').html(time);
        if(time === 0) {
            clearInterval(timerInterval);
            $timer.removeClass('disabled');
            $timer.find('span').css('display', 'none');
        }
    }, 1000);

    return timerInterval;
}

//Insert user data to hidden input for next use
function insertIserData(id, name, surname, phone, email) {
    var $rFirst = $('#row_first');
    $rFirst.find('input[name="user_id"]').val(id);
    $rFirst.find('input[name="user_name"]').val(name);
    $rFirst.find('input[name="user_surname"]').val(surname);
    $rFirst.find('input[name="user_phone"]').val(phone);
    $rFirst.find('input[name="user_email"]').val(email);
}

/**
 *
 * @param index
 */
function ecommerceGa(index) {
    if(window.productsGA) {
        dataLayer.push({
            'ecommerce': {
                'currencyCode': 'UAH',
                'checkout': {
                    'actionField': {'step': index},
                    'products': window.productsGA
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Checkout Step ' + index,
            'gtm-ee-event-non-interaction': 'False',
        });
    }
}

/**
 *
 * @param name
 */
function ecommerceGaDelivery(name) {
    if(window.productsGA) {
        dataLayer.push({
            'ecommerce': {
                'currencyCode': 'UAH',
                'checkout': {
                    'actionField': {'step': 3, 'option': ''+ name +''},
                    'products': window.productsGA
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Checkout Step 3',
            'gtm-ee-event-non-interaction': 'False',
        });
    }
}

/**
 *
 * @param name
 */
function ecommerceGaPay(name) {
    if(window.productsGA) {
        dataLayer.push({
            'ecommerce': {
                'currencyCode': 'UAH',
                'checkout': {
                    'actionField': {'step': 4, 'option': ''+ name +''},
                    'products': window.productsGA
                }
            },
            'event': 'gtm-ee-event',
            'gtm-ee-event-category': 'Enhanced Ecommerce',
            'gtm-ee-event-action': 'Checkout Step 4',
            'gtm-ee-event-non-interaction': 'False',
        });
    }
}
